function NXTotalOrder() {
  return (
    <svg
      width="54"
      height="50"
      viewBox="0 0 54 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="34" cy="20" r="20" fill="#E7F7EF" />
      <circle cx="11" cy="3" r="3" fill="#E7F7EF" />
      <path
        d="M10 45C11.841 45 13.3333 43.5076 13.3333 41.6667C13.3333 39.8257 11.841 38.3333 10 38.3333C8.15905 38.3333 6.66667 39.8257 6.66667 41.6667C6.66667 43.5076 8.15905 45 10 45Z"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3333 45C30.1743 45 31.6667 43.5076 31.6667 41.6667C31.6667 39.8257 30.1743 38.3333 28.3333 38.3333C26.4924 38.3333 25 39.8257 25 41.6667C25 43.5076 26.4924 45 28.3333 45Z"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.3333 38.3333H10V15H6.66667"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 18.3333L33.3333 20L31.6667 31.6667H10"
        stroke="#277200"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXTotalOrder;
